module.exports = __webpack_public_path__ + "static/textx2-f2ab58a1e8b2244690907f650d6ba9f5.png";